'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const CaretDownIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="CaretDownIcon">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.17785 9.55097C8.07964 9.64919 7.9204 9.64919 7.82219 9.55097L5.07613 6.80491C4.9177 6.64648 5.0299 6.37559 5.25396 6.37559L10.7461 6.37559C10.9701 6.37559 11.0823 6.64648 10.9239 6.80491L8.17785 9.55097Z"
          fill={sx?.color || '#051C33'}
        />
      </svg>
    </SvgIcon>
  )
}

CaretDownIcon.propTypes = {
  sx: PropTypes.object
}
